import { useEffect } from "react";
import Accessible from "@material-ui/icons/Accessible";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { usePriorityCreate } from "../../../services/api-tansquery/priority/create";
import Form from "./form";

export default function PriorityCreate() {
    const { setBreadcrumbs } = useBreadcrumbs();
    const mutation = usePriorityCreate();

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Prioridades",
                    path: "/prioridades",
                    icon: Accessible,
                },
                {
                    label: "Gerenciar",
                    path: "",
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Form
            mutation={mutation}
        />
    );
}